
const EMAIL_REGEX = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

const ID_NUM_NOT_VALID = 'Invalid id number';
const EMAIL_NOT_VALID = 'Invalid email address';

export const Validators = {
  email: (value, errorMsg) => {
    return value && !EMAIL_REGEX.test(value) ? errorMsg || EMAIL_NOT_VALID : undefined;
  },
  required: (value, errorMsg) => {
    return value === null || value === undefined || value === '' ? errorMsg || 'Please enter a value' : undefined;
  },
  idNumber: (str, errorMsg) => {
    if (!str) {
      return;
    }
    let IDnum = String(str);

    if ((IDnum.length > 9) || (IDnum.length < 5)) {
      return errorMsg || ID_NUM_NOT_VALID;
    }

    if (Number.isNaN(IDnum)) {
      return errorMsg || ID_NUM_NOT_VALID;
    }

    // The number is too short - add leading 0000
    if (IDnum.length < 9) {
      while (IDnum.length < 9) {
        IDnum = `0${IDnum}`;
      }
    }

    let mone = 0, incNum;
    for (let i = 0; i < 9; i++) {
      incNum = Number(IDnum.charAt(i));
      incNum *= (i%2)+1;
      if (incNum > 9) {
        incNum -= 9;
      }
      mone += incNum;
    }

    if (mone%10 !== 0) {
      return errorMsg || ID_NUM_NOT_VALID;
    }
  },
  notEInput(e) {
    if ((e.which || e.keyCode) === 69) {
      e.preventDefault();
    }
  }
};

export const Parsers = {
  number: (change) => {
    return (val, fieldName) => {
      if (!val || Number.isNaN(val)) {
        change(fieldName, null);
        return;
      }
      return Number(val);
    };
  },
  sanitizeString: (value) => {
    const trimmedVal = value ? String(value).trim() : null;
    return trimmedVal || null;
  }
};
